import React from "react";
import { styled } from "styled-components";
import { QuasiRadio } from "../../RadioBox";
const Container = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem 1.25rem 0.5rem;

  > p {
    margin: 0;
    font-size: 1.25rem;
  }

  ${QuasiRadio.toString()} {
    margin-right: 0.75rem;
  }
`;
const IconContainer = styled.div `
  padding-left: 1.5rem;
  align-items: flex-end;
  display: flex;

  svg {
    width: 2rem;
    height: auto;
    display: block;
  }
`;
const TripRadioBoxHeader = ({ checked, icon: Icon, label, showRadio, LeadingIcon, TailingIcon, }) => (React.createElement(Container, null,
    showRadio && React.createElement(QuasiRadio, { isChecked: checked }),
    React.createElement("p", null, label),
    Icon ? (React.createElement(IconContainer, null,
        LeadingIcon ? React.createElement(LeadingIcon, null) : null,
        React.createElement(Icon, null),
        TailingIcon ? React.createElement(TailingIcon, null) : null)) : null));
export default TripRadioBoxHeader;
//# sourceMappingURL=TripRadioBoxHeader.js.map